import {
  FORM_BUILDER_MODAL,
  FORM_BUILDER_FORM_LIST,
  FORM_BUILDER_FORM_NAME,
  FORM_BUILDER_SAVED_LIST,
  FORM_BUILDER_TOTAL_SAVED_LIST,
  FORM_CHANGED_FOR_UPDATE,
} from "FormBuilderAction";

export function formBuilderModal(state = {}, action) {
  switch (action.type) {
    case FORM_BUILDER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function formList(state = [], action) {
  switch (action.type) {
    case FORM_BUILDER_FORM_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function formName(state = {}, action) {
  switch (action.type) {
    case FORM_BUILDER_FORM_NAME:
      return action.payload;
    default:
      return state;
  }
}

export function formBuildeList(state = {}, action) {
  switch (action.type) {
    case FORM_BUILDER_SAVED_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function totalFormBuildeList(state = {}, action) {
  switch (action.type) {
    case FORM_BUILDER_TOTAL_SAVED_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function formChanged(state = {}, action) {
  switch (action.type) {
    case FORM_CHANGED_FOR_UPDATE:
      return action.payload;
    default:
      return state;
  }
}
